// extracted by mini-css-extract-plugin
module.exports = {"paper":"Kako_paper__3zAsV"};